<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Listagem dos Planos de Conta.</span>
                <br />
                <span class="navigation">Cadastros > Planos de Conta</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-2">
              <label for="descServico">Layout:</label>
              <span class="p-fluid">
                <a href="https://s3.amazonaws.com/el.com.br/nfse/layout_pgcc_nfse.pdf" style="padding-left: 2px;"
                  target="_blank">Clique aqui e faça o download do Layout</a>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-2">
              <label>Importação dos Planos de Conta em TXT, selecione um arquivo para importação:</label>
              <span class="p-fluid">
                <input type="file" @change="onFileChanged" accept=".txt" />
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <label> </label>
              <span class="p-fluid">
                <Button v-if="selectedFile" @click="onUpload()" label="Upload" type="button"
                  class="p-button-primary mr-2 p-button-success" icon="pi pi-check" />
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-2">
              <label for="filtro">Filtro:</label>
              <span class="p-fluid">
                <InputText type="text" id="filtro" v-model="filtro" />
              </span>
            </div>
            <div class="mb-2">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button label="Pesquisar" title="Pesquisar" icon="pi pi-search" :disabled="search"
                  @click="pesquisar()" />
              </span>
            </div>
            <div class="mb-2" style="padding-left:2px">
              <label for="btnSearch">&nbsp;</label>
              <span class="p-fluid">
                <Button label="Limpar" title="Limpar" icon="pi pi-trash" :disabled="search" @click="clear()" />
              </span>
            </div>
          </div>
          <div class="row">
            <DataTable :value="pgccList" :paginator="true" :rows="10" class="p-datatable-responsive" :autoLayout="true">
              <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <Button type="button" icon="pi pi-pencil" style="margin-right: .5em"
                    @click="detail(slotProps.data.id)"></Button>
                  <Button type="button" icon="pi pi-trash" @click="confirmRemove(slotProps.data.id)"
                    v-if="slotProps.data.dataVigenciaFinal === null"></Button>
                  <Button type="button" icon="pi pi-check" @click="confirmAtivar(slotProps.data.id)"
                    v-if="slotProps.data.dataVigenciaFinal !== null"></Button>
                </template>
              </Column>
              <Column field="conta" header="Código"></Column>
              <Column field="nome" header="Nome"></Column>
              <Column field="tipo.nome" header="Tipo Cobrança"></Column>
              <Column field="contaSuperior" header="Conta Superior"></Column>
              <Column field="dataVigenciaInicialDescricao" header="Data Inicio"></Column>
              <Column field="dataVigenciaFinalDescricao" header="Data Fim"></Column>
            </DataTable>
          </div>
          <hr />

          <div class="row">
            <span class="p-fluid mr-2">
              <router-link to="/pgccCadastro">
                <Button type="button" icon="pi pi-plus" label="Novo" title="Novo" />
              </router-link>
            </span>
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Aviso" :visible.sync="display" :style="{ width: '30vw' }" :modal="true">
      Confirma a remoção do Registro?
      <template #footer>
        <Button label="Sim" icon="pi pi-check" @click="remove" title="Sim" />
        <Button label="Não" icon="pi pi-times" @click="close" title="Não" class="p-button-secondary" />
      </template>
    </Dialog>
    <Dialog header="Aviso" :visible.sync="displayAtivar" :style="{ width: '30vw' }" :modal="true">
      Confirma a ativação do Registro?
      <template #footer>
        <Button label="Sim" icon="pi pi-check" @click="ativar" title="Sim" />
        <Button label="Não" icon="pi pi-times" @click="close" title="Não" class="p-button-secondary" />
      </template>
    </Dialog>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import PgccService from "../services/nfse/pgcc.service";

export default {
  name: "pgcc",
  data() {
    return {
      loading: false,
      display: false,
      displayAtivar: false,
      search: false,
      currentUser: null,
      filtro: "",
      pgccList: [],
      pgccId: null,
      selectedFile: null,
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.pesquisar();
  },
  methods: {
    onFileChanged(event) {
      const file = event.target.files[0];
      this.selectedFile = file;
    },
    onUpload() {
      this.processando(true);
      PgccService.upload(
        this.currentUser.usuario.idCliente,
        this.currentUser.contribuinte.idContribuinte,
        this.selectedFile
      ).then(
        (response) => {
          console.log(response);
          this.pesquisar();
          this.$root.$emit(
            "alert:success",
            "Planos de Conta importados com sucesso!"
          );
        },
        (error) => {
          let errorMessage = "Houve um problema ao realizar o Upload!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$root.$emit("alert:error", errorMessage);
        }
      );
      this.processando(false);
    },
    clear() {
      this.filtro = "";
      this.pesquisar();
    },
    pesquisar() {
      this.search = true;
      PgccService.findAllByFiltro(
        this.currentUser.contribuinte.idContribuinte,
        this.filtro
      ).then(
        pgcc => {
          this.pgccList = pgcc.data;
        },
        error => {
          let errorMessage = "Houve um problema listar Planos de Conta!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
      this.search = false;
    },
    detail(pgccId) {
      this.$router.push({ name: "pgccCadastro", params: { id: pgccId } });
    },
    confirmRemove(pgccId) {
      this.pgccId = pgccId;
      this.display = true;
    },
    confirmAtivar(pgccId) {
      this.pgccId = pgccId;
      this.displayAtivar = true;
    },
    close() {
      this.pgccId = null;
      this.display = false;
      this.displayAtivar = false;
    },
    remove() {
      PgccService.remove(this.pgccId).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Plano de Conta removido com sucesso"
          });
          setTimeout(async () => {
            await this.pesquisar();
            this.display = false;
          }, 250);
        },
        error => {
          let errorMessage = "Houve um problema remover o Plano de Conta!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    ativar() {
      PgccService.ativar(this.pgccId).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Plano de Conta ativado com sucesso"
          });
          setTimeout(async () => {
            await this.pesquisar();
            this.displayAtivar = false;
          }, 250);
        },
        error => {
          let errorMessage = "Houve um problema ao ativar o Plano de Conta!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  }
};
</script>

<style scoped></style>